import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { vocabularize } from "src/Common/vocab";
import { useState, forwardRef, useEffect } from "react";
import { WO_TYPE_LIST } from "src/Common/contants";
import ServiceTypeDropdown from "./dropdown/ServiceTypeDropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerModal from "src/Common/datepickermodal";
import DateInput from "src/Components/Input/dateinput";
import UserDropDown from "./AssignTech/userdropdown";
import UserService from "src/Services/API/user.service";
import { handleError } from "src/Common/function";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

function ApproveModal({
  shown,
  onCancelClicked,
  onApproveClicked,
  defaultServiceType = null,
  lockServiceType = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  // const [type, setType] = useState(0);
  const [serviceType, setServiceType] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [primaryTech, setPrimaryTech] = useState(null);
  const [technicians, setTechnicians] = useState([]);
  const [isUserDropDownOpen, setIsUserDropDownOpen] = useState(false);

  const StartInput = forwardRef(({ value, onClick }, ref) => <DateInput text={value} onClick={onClick} />);

  const primaryTechSelected = (i) => {
    if (i == -1) {
      setIsUserDropDownOpen(false);
    } else if (i == -2) {
      setIsUserDropDownOpen(true);
    } else {
      setPrimaryTech(technicians[i]);
      setIsUserDropDownOpen(false);
    }
  };

  // const typeSelected = (index) => {
  //   setType(index);
  // };

  useEffect(() => {
    getTechnicians();
  }, [branch]);

  // Reset every input whenever the modal is re-opened so a previous
  // (cancelled) approval attempt doesn't leak into the next one. Type of
  // Service starts at what the customer asked for (service or a quote).
  useEffect(() => {
    setServiceType(defaultServiceType);
    setStartDate(null);
    setPrimaryTech(null);
    setIsUserDropDownOpen(false);
  }, [shown]);

  const getTechnicians = async () => {
    // Roles are dynamic (managed in IAM), so the picker lists all enabled
    // users instead of hardcoding role names.
    UserService.getUsersForAssign(null, branch)
      .then((response) => {
        if (response.status == 200) {
          setTechnicians(
            response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name)),
          );
        }
      })
      .catch((error) => handleError(error));
  };

  const approveClicked = () => {
    // The WO number is auto-assigned by the backend from the branch prefix
    // at approval time, so nothing to validate here.
    onApproveClicked(serviceType, startDate, primaryTech);
  };

  return (
    shown && (
      <div className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen  flex items-center justify-center z-30 bg-black/50">
        <OutsideClickHandler onOutsideClick={onCancelClicked}>
          <div className="w-[440px] px-5 py-5 bg-white p-[18px] flex flex-col  rounded-[6px] shadow-2xs relative">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5 text-center">
              {vocabularize("APPROVE WORK ORDER")}
            </p>
            <p className="text-[11px] font-OpenSansRegular text-subTitleColor mb-2">
              The work order # will be assigned automatically on approval.
            </p>

            <div className="h-[60px] w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Type of Service</p>
              {/* A customer's quote request is a Quoted Job already; nothing to pick. */}
              {lockServiceType && defaultServiceType ? (
                <p className="h-[30px] flex items-center text-[13px] font-OpenSansRegular text-titleColor">
                  {defaultServiceType.serviceType}
                </p>
              ) : (
                <ServiceTypeDropdown selectedItem={serviceType} onSelect={setServiceType} />
              )}
            </div>

            <div className="h-[60px] w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Start Date</p>

              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                }}
                customInput={<StartInput />}
              />
            </div>

            <div className="w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                Assign Primary Technician
              </p>
              <UserDropDown
                options={technicians}
                selectedUser={primaryTech}
                onSelect={primaryTechSelected}
                isOpen={isUserDropDownOpen}
              />
            </div>

            <div className="flex items-center justify-between gap-3 mt-3">
              <div
                onClick={onCancelClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                data-testid="approve-submit"
                onClick={approveClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                APPROVE
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default ApproveModal;
